import { render } from "./DialogRecieve.vue?vue&type=template&id=5e83d1a6"
import script from "./DialogRecieve.vue?vue&type=script&lang=js"
export * from "./DialogRecieve.vue?vue&type=script&lang=js"
script.render = render

export default script